module.exports = __webpack_public_path__ + "img/advantage.c93ed730.png";